import { ref } from 'vue'
import stores from '@/storage/stores'

export const catalogueBase = ref(stores.state.storeData.category)
export const logo = ref<string | null>(null)
export const isNavbarVisible = ref<boolean>(true)
export const settingNavbar = ref()
